import React from 'react';
import { Button } from '../components/ui/button';
import { Instagram, Linkedin, Mail, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import '../styles/About.css';

const AboutKristenBarnett = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO 
        title="About Kristen Barnett | Highest Good Ventures"
        description="Kristen Barnett is the founder of Highest Good Ventures, a multi-venture portfolio company based in Mill Valley, CA."
      />
      <div className="about-page">
        <div className="about-container">
          <Button
            variant="outline"
            className="back-button"
            onClick={() => navigate('/')}
          >
            <ArrowLeft size={18} />
            Back to Home
          </Button>

          <div className="about-hero">
            <div className="about-hero-image">
              <img
                src="https://customer-assets.emergentagent.com/job_good-ventures-1/artifacts/no45is31_DSC01007.JPG"
                alt="Kristen Barnett, founder of Highest Good Ventures"
                className="hero-portrait"
              />
            </div>

            <div className="about-hero-content">
              <h1 className="about-h1">About Kristen Barnett</h1>
              
              <p className="about-intro-large">
                Kristen Barnett is the founder of Highest Good Ventures, a multi-venture portfolio company based in Mill Valley, CA. A Cornell-educated entrepreneur and BCG-trained management consultant, Kristen Barnett spent over a decade scaling venture-backed food tech companies including Dig Inn, Zuul, and Hungry House before founding Highest Good Ventures. She is the creator of Tarot for Bros™, a tarot card company for men, designed to make self-reflection accessible.
              </p>

              <div className="about-social-links">
                <Button
                  variant="outline"
                  onClick={() => window.open('https://www.instagram.com/itskristenbarnett/', '_blank')}
                  className="about-cta"
                >
                  <Instagram size={18} />
                  Follow on Instagram
                </Button>
                <Button
                  variant="outline"
                  onClick={() => window.open('https://www.linkedin.com/in/kcbarnett/', '_blank')}
                  className="about-cta"
                >
                  <Linkedin size={18} />
                  LinkedIn
                </Button>
                <Button
                  variant="outline"
                  onClick={() => window.open('https://itskristen.substack.com/?r=6db7y9&utm_campaign=pub-share-checklist', '_blank')}
                  className="about-cta"
                >
                  <Mail size={18} />
                  Substack
                </Button>
                <Button
                  variant="outline"
                  onClick={() => window.location.href = 'mailto:kristen@highestgoodventures.com'}
                  className="about-cta"
                >
                  <Mail size={18} />
                  Contact Kristen
                </Button>
              </div>
            </div>
          </div>

          <div className="about-full-bio">
            <h2 className="bio-section-heading">Full Biography</h2>
            
            <div className="bio-content">
              <p className="bio-paragraph">
                Kristen Barnett is a serial entrepreneur and founder of Highest Good Ventures. She grew up in rural Massachusetts with a deep attunement to nature and subsequently studied at Cornell University, from which she launched her career at The Boston Consulting Group. After a battle with chronic Lyme disease sent her searching for answers in food and healing, she left consulting to pursue a career in the food industry that would prove far more consequential than she expected.
              </p>

              <p className="bio-paragraph">
                Over the next decade, she became a recognized voice in the growing foodtech industry: Director of Strategic Operations at Dig Inn, where she led supply chain and launched their first ghost kitchen; then Chief Operating Officer at Zuul, acquired by Kitchen United in 2021; then founder and CEO of Hungry House, the venture-backed "anti-ghost-kitchen" featured in The New Yorker, Business Insider, EATER and others. She created a sister company, Culinary Creators Worldwide, a media and marketing agency for food creators — building a body of work grounded in the belief that the best businesses are built on story, not just scale.
              </p>

              <p className="bio-paragraph">
                Then it all stopped. She burnt out and went searching for the next chapter. Having stripped away the armor of the founder's identity, she asked hard questions to find her new direction. What does it mean to build something that truly lasts? Where does ancient wisdom fit in a world drowning in information and starved for meaning and connection? Out of that reckoning came Highest Good Ventures, a multi-venture portfolio at the intersection of the spiritual economy, regenerative capitalism, and culturally resonant storytelling. Through this platform, Kristen builds brands, products and experiences designed to reconnect people with what is most essentially human.
              </p>

              <p className="bio-paragraph">
                Her flagship project, Tarot for Bros™, is a tarot deck company producing decks built to bring mythic self-inquiry to modern men through the languages they already respect — craft, irreverence, and depth without pretension. With a visual identity rooted in Esoteric Americana and leveraging the teachings of Carl Jung and other spiritual thought leaders, it is equal parts cultural provocation and genuine tool for reflection. Gone are the days of tarot being relegated to female psychics and velvet-adorned backrooms–the practice of pulling cards and receiving wisdom is for everyone.
              </p>

              <p className="bio-paragraph">
                Kristen is based in Mill Valley, CA and spends her time hosting gatherings in her gardens with her community, enjoying the beautiful Northern California nature and, of course, reading tarot cards.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutKristenBarnett;
